
import { Vue, Component } from 'vue-property-decorator';
import HeaderNav from '@/components/header-nav.vue';
import { NotiFromType } from '@/const/notification';
import { Action } from 'vuex-class';
import PerfNotificationDetail from '../dashboard/perf/perf-notification-detail.vue';
import notificationState from '@/store/modules/notification/index';
import accountState from '@/store/modules/account/index';
import { computed, ref } from 'vue-demi';
import { sessionStorageGetItem } from '@/utils/localStorage';

@Component({
  name: 'Reminders',
  components: {
    HeaderNav,
    PerfNotificationDetail,
  },
})
export default class Reminders extends Vue {
  @Action('notification/getBannerListSuggestions') getBannerList: any;

  NotiFromType = NotiFromType.dashboard;
  originalNotiList = computed(() => notificationState.state.bannerList);
  aadvid = computed(() => accountState.getters.adverId(accountState.state));
  bannerList = ref([]);

  get ifNoNoti() {
    return this.bannerList.value.length === 0;
  }

  async fetchRenderedData(): Promise<void> {
    await this.getBannerList();
    this.bannerList.value = this.originalNotiList.value.filter(item => {
      const key = `noti-advId-${this.aadvid.value}-notiId-${item?.id}-${item.priority}`;
      const timestamp = sessionStorageGetItem(key) ?? 0;
      return Number(timestamp) < Number(Date.now());
    });
  }

  async created() {
    await this.fetchRenderedData?.();
  }

  go2Dashboard(): void {
    this.$router.back();
  }
}
